import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {listOrderedPlatforms} from '../../../../app.constants';
import {InfluencerSuggestion, InfluencerSuggestionState} from '../../../../../models/influencer-suggestion';

@Component({
  selector: 'status-influencer-suggestion',
  templateUrl: './status-influencer-suggestion.component.html',
  styleUrls: ['./status-influencer-suggestion.component.scss']
})
export class StatusInfluencerSuggestionComponent implements OnInit {

  @Input()
  public influencer: InfluencerSuggestion;
  @Input()
  public index: number;
  @Input()
  public handle: string;
  @Output()
  public addNewInfluencerManuallyEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public showMultipleSelectionEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public retryAfterErrorEvent: EventEmitter<any> = new EventEmitter<any>();
  public platformList: any[] = [];

  constructor() { }

  ngOnInit() {
    this.platformList = listOrderedPlatforms;
  }

  get isUnknownInfluencer() {
    return this.influencer.state === InfluencerSuggestionState.NOT_FOUND;
  }

  get isProcessing() {
    return this.influencer.state === InfluencerSuggestionState.PROCESSING;
  }

  get isMultiple() {
    return this.influencer.state === InfluencerSuggestionState.MULTIPLE_SUGGESTIONS;
  }

  get hasError() {
    return this.influencer.state === InfluencerSuggestionState.ERROR;
  }

  get isSingle() {
    return this.influencer.state === InfluencerSuggestionState.SINGLE_SUGGESTION;
  }

  public addNewInfluencer() {
    this.addNewInfluencerManuallyEvent.emit({
      handle: this.handle,
      index: this.index,
      influencer: this.influencer
    });
  }

  hasPlatform(platformId: string, influencer: InfluencerSuggestion) {
    if (!influencer.channels) {
      return false;
    }

    return influencer.channels.findIndex((channel) => {
      if (channel.platform) {
        return channel.platform.id === platformId;
      } else {
        return channel.platform_id === platformId;
      }
    }) >= 0;
  }

  public openMultipleSelection() {
    this.showMultipleSelectionEvent.emit(this.handle);
  }

  public retryAddInfluencer() {
    this.retryAfterErrorEvent.emit({
      index: this.index,
      influencer: this.influencer
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/main/group-details/add-influencer-group/status-influencer-suggestion/status-influencer-suggestion.component.ts